import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {toFixedFeatureCost} from "../../../misc/helpers";
import {getPriceWithIncluded} from "../../../misc/priceFunctions";

const RowItemPrice = (props) => {

  let {
    currentFeature,
    fabricatorData,
    isPhoneNumberValidated,
    rowItems,
    qtActiveCategory,
    intl,
  } = props;
  const fabricatorSettings = fabricatorData.settings;

  if (fabricatorSettings.leadCaptureShoppingCart && !isPhoneNumberValidated) {
    return null
  }

  const existingItem = rowItems.find(rItem => rItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id);

  const quantity = existingItem ? existingItem.quantity : 0;

  let price = 0;
  if (quantity) {
    price = toFixedFeatureCost(currentFeature, quantity, qtActiveCategory);
  }

  // const unit = getFeatureUnit(selectionFeatureInfo, intl, fabricatorData, quantity);

  return (
    <div className="product-action__price">
      <div className="product-action__price-num bold">
        {!price ? null : getPriceWithIncluded(price, currentFeature, fabricatorData, intl.messages)}
      </div>
      {/*<div className="product-action__price-unit bold">(${selectionFeatureInfo.dbFeature.unit || "Each"})</div>*/}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {rowItems} = store.selectionState;
  return {
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    rowItems,
    qtActiveCategory: store.qtState.qtActiveCategory,
  };
};

const mapDispatchToProps = {

};

RowItemPrice.propTypes = {
  currentFeature: PropTypes.object,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RowItemPrice)
)
